import React from "react";
import { Grid, Tooltip } from "@material-ui/core";
import { ButtonSizeOptions } from "@loanbossinc/component-library";
import DeleteIcon from "@material-ui/icons/Delete";

import CalcIconBlue from "../../calcIconBlue.svg";

import { Row } from "./styles";
import {
  FieldIconWrapper,
  FieldLeftContentWrapper,
  FieldLevelWrapper,
  FieldNameTypeWrapper,
  FieldNameWrapper,
  FieldRightContentWrapper,
  FieldTypeWrapper,
  FieldWrapper,
  StyledChevronRight,
  StyledPrimaryButton
} from "./fieldListItemStyles";

export const FieldListItem = props => {
  const {
    deal,
    field,
    onClick,
    isFromFile = false,
    setFieldSelections,
    isChoosingForAccountingIntegration,
    onChooseForAccountingIntegration,
    accountingIntegrations
  } = props;

  let fieldTypeLabel = "Unknown";
  if (field.isCalculated) {
    fieldTypeLabel = "Calculated";
  }

  if (field.isFromFile) {
    fieldTypeLabel = "From file";
  }
  
  if (field.isBalanceOverride || field.isFinanceOverride) {
    fieldTypeLabel = "Cashflow Override";
  }


  if (field.isHardCoded) {
    fieldTypeLabel = "Manual input";
  }

  if (field.isFromLoanBoss) {
    fieldTypeLabel = "Derived by LoanBoss";
  }

  if (field.isFromRentRoll) {
    fieldTypeLabel = "From rent roll";
  }

  let levelLabel = field.level;
  if (levelLabel === "property") {
    levelLabel = "Property";

    if (Boolean(field.propertyId) && Boolean(deal) && Boolean(deal.properties)) {
      const property = deal.properties.find(p => p.id === field.propertyId);
      if (property) {
        levelLabel = property.name;
      }
    }
  } else if (levelLabel === "deal") {
    levelLabel = "Deal-level";
  } else {
    levelLabel = "Universal";
  }

  /*
   * NOTE:  We want to default to disabling the delete button so that the user can't delete a field before we finish
   *        checking if it is used for accounting integrations. -- Jonathan Byrne 01/04/2022
   */
  const hasAccountingIntegrationMappings =
    !accountingIntegrations || accountingIntegrations.filter(accountingIntegration => accountingIntegration.valueFieldId === field.id).length > 0;

  return (
    <div>
      <Row>
        <Grid container>
          <FieldWrapper>
            <FieldLeftContentWrapper>
              <FieldIconWrapper>
                <img src={CalcIconBlue} alt="Calc Icon" height={24} width={24} />
              </FieldIconWrapper>
              <FieldNameTypeWrapper>
                <FieldNameWrapper>{field.name}</FieldNameWrapper>
                <FieldTypeWrapper>{fieldTypeLabel}</FieldTypeWrapper>
              </FieldNameTypeWrapper>
            </FieldLeftContentWrapper>
            {isFromFile ? (
              <StyledPrimaryButton onClick={() => onClick(field)} size={ButtonSizeOptions.sm} label="Select" isFromFile={isFromFile} />
            ) : (
              <FieldRightContentWrapper>
                <div style={{ display: "flex", cursor: "pointer" }}>
                  <FieldLevelWrapper onClick={() => onClick(field)}>{levelLabel}</FieldLevelWrapper>
                  <StyledChevronRight onClick={() => onClick(field)} />
                </div>
                {!hasAccountingIntegrationMappings && (
                  <DeleteIcon
                    style={{ marginLeft: "1em", cursor: "pointer", color: "#005AA9" }}
                    onClick={() => setFieldSelections({ fieldIdToDelete: field.id, deleteDialogOpen: true, fieldToDelete: field })}
                  />
                )}
                {hasAccountingIntegrationMappings && (
                  <Tooltip title="The accounting integration mappings to this field must be removed before the field can be deleted">
                    <DeleteIcon color="disabled" style={{ marginLeft: "1em" }} />
                  </Tooltip>
                )}
                {isChoosingForAccountingIntegration && (
                  <StyledPrimaryButton onClick={() => onChooseForAccountingIntegration(field)} size={ButtonSizeOptions.smFluid} label="Select" />
                )}
              </FieldRightContentWrapper>
            )}
          </FieldWrapper>
        </Grid>
      </Row>
    </div>
  );
};

export default FieldListItem;
